<script setup>
import { computed, onMounted } from 'vue'
import ClientTodayView from '@/components/today/ClientTodayView.vue'
import { useClientTodayStore } from '@/stores/clientToday'
import { usePlanCheckInsStore } from '@/stores/planCheckIns'

definePage({
  meta: {
    layout: 'client',
    clientArea: true,
  },
})

const { t } = useI18n()
const todayStore = useClientTodayStore()
const checkInsStore = usePlanCheckInsStore()

const load = async () => {
  try {
    await todayStore.fetchToday()
  }
  catch {
    // error surfaced via store.error
  }
}

onMounted(load)

const onChecked = async () => {
  await load()
}

const formattedDate = computed(() => {
  const on = todayStore.today?.on
  if (!on)
    return ''

  try {
    return new Intl.DateTimeFormat('nl-NL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(`${on}T12:00:00`))
  }
  catch {
    return on
  }
})
</script>

<template>
  <div
    class="pa-6 mx-auto"
    style="max-inline-size: 720px;"
  >
    <h1 class="text-h4 mb-1">
      {{ t('clientToday.title') }}
    </h1>
    <p
      v-if="formattedDate"
      class="text-body-2 text-medium-emphasis mb-6"
    >
      {{ formattedDate }}
    </p>
    <p
      v-else
      class="text-body-2 text-medium-emphasis mb-6"
    >
      {{ t('clientToday.subtitle') }}
    </p>

    <p
      v-if="todayStore.loading && !todayStore.today"
      class="text-body-2"
      role="status"
    >
      {{ t('clientToday.loading') }}
    </p>

    <VAlert
      v-else-if="todayStore.error && !todayStore.today"
      type="error"
      variant="tonal"
      role="alert"
      class="mb-4"
    >
      {{ todayStore.error }}
      <div class="mt-2">
        <VBtn
          size="small"
          variant="tonal"
          @click="load"
        >
          {{ t('clientToday.retry') }}
        </VBtn>
      </div>
    </VAlert>

    <ClientTodayView
      v-else-if="todayStore.today"
      :today="todayStore.today"
      :recording="checkInsStore.recording"
      :recording-key="checkInsStore.recordingKey"
      @checked="onChecked"
    />
  </div>
</template>
